import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

import flatpickr from "flatpickr";

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent extends FieldType<FieldTypeConfig> {

  ngOnInit() {
    flatpickr('#calendar', {
      dateFormat: 'm/d/Y',
      defaultDate: this.props['defaultValue']
    });
  }
}
